"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./MessageInput.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MessageInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onChange = _ref.onChange,
      onEnter = _ref.onEnter,
      maxChars = _ref.maxChars,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder;
  var areaRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        areaRef.current.focus();
      }
    };
  });

  var handleChange = function handleChange(e) {
    var newVal = e.currentTarget.value;
    if (maxChars && newVal.length > maxChars) return;
    onChange(newVal);
  };

  var calculateRows = function calculateRows() {
    areaRef.current.rows = 1;
    var newRows = Math.ceil((areaRef.current.scrollHeight - 44) / 20);
    areaRef.current.rows = 1 + newRows;
  };

  (0, _react.useLayoutEffect)(calculateRows, [value]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      if (!(e.shiftKey || e.ctrlKey || e.altKey)) {
        onEnter && onEnter();
      } else {
        onChange(value + '\r\n');
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-message-input' + (disabled ? ' disabled' : '')
  }, /*#__PURE__*/_react["default"].createElement("textarea", {
    ref: areaRef,
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    disabled: disabled,
    placeholder: placeholder,
    rows: 1,
    spellCheck: "true"
  }), maxChars && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-mi-counter"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: value.length === maxChars ? 'gcl-mi-alert' : undefined
  }, value.length), "/", maxChars));
});
MessageInput.propTypes = {
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onEnter: _propTypes["default"].func,
  maxChars: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string
};
var _default = MessageInput;
exports["default"] = _default;